/**
 * @generated SignedSource<<c8c52d21dc85c89095f63d21c99b922c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScheduleTableDataRow_schedule$data = {
  readonly id: string;
  readonly slug: string;
  readonly startTime: string | null;
  readonly endTime: string | null;
  readonly createdAt: string | null;
  readonly updatedAt: string | null;
  readonly " $fragmentType": "ScheduleTableDataRow_schedule";
};
export type ScheduleTableDataRow_schedule = ScheduleTableDataRow_schedule$data;
export type ScheduleTableDataRow_schedule$key = {
  readonly " $data"?: ScheduleTableDataRow_schedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleTableDataRow_schedule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScheduleTableDataRow_schedule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "Schedule",
  "abstractKey": null
};

(node as any).hash = "75ec713219632002e803048ff9f818d2";

export default node;
